<template>
  <a-result status="404" title="404" sub-title="您访问的页面不存在！">
    <template #extra>
      <a-button v-if="hasPermissions" type="primary" @click="toHome">
        返回上一页
      </a-button>
    </template>
  </a-result>
</template>

<script>
import storage from 'store'
export default {
  name: 'Exception404',
  computed: {
    hasPermissions() {
      const permissions = storage.get('permissions')
      const slug = permissions?.slug || []
      return slug.length > 0
    }
  },
  methods: {
    toHome () {
      this.$router.go(-1)
    }
  }
}
</script>
